export default __webpack_public_path__ + "static/media/simon_active.c82d89bc.svg";